// extracted by mini-css-extract-plugin
export default {"root":"index_root_qpkCF"};